<template>
  <v-badge
    v-if="organization.disposition"
    :color="badgeColor"
    dot
    overlap
    bottom
    right
  >
    <v-icon :color="_color" :title="_title" v-bind="$attrs">{{ icon }}</v-icon>
  </v-badge>
  <v-icon v-else :color="_color" :title="_title" v-bind="$attrs">{{
    icon
  }}</v-icon>
</template>

<script>
import { titleCase } from "@tod-ui/helpers/strings";

export default {
  name: "OrganizationIcon",
  props: {
    color: {
      type: String,
      default: null,
    },
    organization: {
      type: Object,
      default: null,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
  },
  computed: {
    _color() {
      return this.color || this.hasDevices ? "primary" : "grey";
    },

    hasDevices() {
      return this.organization.devices && this.organization.devices.length > 0;
    },
    icon() {
      switch (this.organization.type) {
        case "platform":
          return "mdi-shield-account";
        case "application":
          return "mdi-cloud";
        case "organization":
          return "mdi-sitemap";
        case "region":
          return "mdi-selection-multiple-marker";
        case "facility":
          return "mdi-domain";
        case "zone":
          switch (this.organization.subtype) {
            case "zone":
              return "mdi-cast-connected";
            default:
              return "mdi-garage-variant";
          }
        default:
          return "mdi-sitemap";
      }
    },
    _title() {
      if (this.title) return this.title;

      const { type, subtype } = this.organization;
      return (
        titleCase(subtype || type) +
        (this.organization?.disposition
          ? ` - ${titleCase(this.organization.disposition)}`
          : "")
      );
    },
    badgeColor() {
      switch (this.organization?.disposition) {
        case "active":
          return "success";
        case "internal":
          return "blue-grey";
        case "deploying":
        case "maintenance":
          return "warning";
        case "sunsetting":
          return "error";
      }
      return "black";
    },
  },
};
</script>
